<template>
  <v-tooltip v-if="network" top :disabled="!tooltip">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        class="mx-1"
        small
        icon
        :href="networkUrl"
        target="_blank"
      >
        <v-icon class="social-icon">
          {{icon}}
        </v-icon>
      </v-btn>
    </template>
    <span>{{tooltip}}</span>
  </v-tooltip>
</template>

<script>
export default {
    name: "SocialIcon",
    props: {
        network: {
            required: true
        },
        tooltip: {
            type: String
        },
        icon: {
            type: String,
            default: "mdi-web",
            required: true
        }
    },
    computed: {
        networkUrl() {
            return this.network.includes("http") ? this.network : `http://${this.network}`;
        }
    }
};
</script>
